'use strict';
var parent = require('../../actual/instance/concat');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/instance/concat.js
// module id = 618
// module chunks = 13